import { useIsCWFPromptOptionsEnabled } from '@modules/common/hooks';
import { OpenInNewRounded } from '@mui/icons-material';
import { Box, Link, Stack } from '@mui/material';

interface SeePromptExamplesLinkProps {
  label?: string;
}

export const SeePromptExamplesLink = ({
  label = 'See Prompt Examples',
}: SeePromptExamplesLinkProps) => {
  const isCWFPromptOptionsEnabled = useIsCWFPromptOptionsEnabled();

  if (!isCWFPromptOptionsEnabled) {
    return null;
  }

  return (
    <Stack
      component={Link}
      variant="body2"
      underline="hover"
      href="https://helpcenter.enterpret.com/en/articles/9711115-examples-of-wisdom-prompts"
      target="_blank"
      direction="row"
      alignItems="center"
      spacing={0.5}
      flexWrap="nowrap"
    >
      <Box
        color="inherit"
        sx={{
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Box>
      <OpenInNewRounded
        sx={{
          fontSize: '1rem',
          color: 'inherit',
          whiteSpace: 'nowrap',
        }}
      />
    </Stack>
  );
};
